import { Touchable, Video } from "@kalyzee/kast-web-sdk/web-components";
import { ReactIcons } from "@kalyzee/kalyzee-ui";
import { MeetingSourceExtended, useMeetingSelector } from "../../hooks/meeting";
import { MeetingContainerAPI } from "@kalyzee/kast-web-sdk";

import styles from "./MediaSourceViewer.module.css";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";

export interface MediaSourceViewerProps {
  meetingAPI: MeetingContainerAPI;
  sources: MeetingSourceExtended[];
  onClick?: () => void;
  selected?: boolean;
}

export const MediaSourceViewer: React.FC<MediaSourceViewerProps> = ({
  meetingAPI,
  sources,
  onClick,
  selected,
}) => {
  const [medias] = useMeetingSelector(meetingAPI, (state) => state.session?.medias);
  const selfStreams = useAppStoreSelector(store => store.selfStreams);

  if (!selfStreams) return null;

  // Taking first visible for now, TODO selection
  const visibleSource = sources.find(s => s.visible);
  if (!visibleSource) return null;

  let localStream: MediaStream | undefined = undefined;

  const media = medias?.find((m) => m.name === visibleSource.name);
  if (media) {
    localStream = selfStreams[media.id];
  }

  return (
    <Touchable
      className={styles.container}
      onPress={onClick}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 4,
          overflow: "hidden", // crop video
          height: "100%",
          width: 90,
        }}
      >
        {localStream ? (
          <Video
            style={{ flex: 1, height: "100%", minWidth: 0, objectFit: "cover" }}
            src={localStream}
            autoPlay
            muted
          />
        ) : (
          <div
            style={{
              fontSize: "0.6em",
              flex: 1,
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Pas de Media
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px 3px",
          height: "100%",
        }}
      >
        <ReactIcons.Settings  
          style={{
            width: 25,
            height: 25,
            color: selected ? "var(--color-element-pink)" : "var(--color-secondary-side-bar-icon)",
          }}
        />
      </div>
    </Touchable>
  );
}